import { Input, Button, Typography, message } from 'antd';
import { CopyOutlined } from '@ant-design/icons';

const CopyablePlatformLinks = ({ 
  platform,
  link,
  label,
  maxLength = 30 
}) => {
  const truncateText = (text) => {
    return text.length > maxLength 
      ? `${text.substring(0, maxLength)}...` 
      : text;
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(link);
    message.success(`${platform.charAt(0).toUpperCase() + platform.slice(1)} link copied!`);
  };

  return (
    <>
      <Typography.Title level={5} className="mt-0 text-left">
        {label}
      </Typography.Title>
      
      <div className="flex items-center">
        <Input
          value={truncateText(link)}
          readOnly
          className="flex-1 rounded-r-none border-r-1 hover:border-inherit hover:shadow-none focus:border-inherit focus:shadow-none"
        />
        <Button 
          icon={<CopyOutlined />} 
          onClick={handleCopyLink}
          className="h-8 flex items-center justify-center rounded-l-none border-l-1"
        />
      </div>
    </>
  );
};

export default CopyablePlatformLinks;